import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { FieldDataContext } from 'stores/FieldDataStore'
import { LoadingOverlay, FlexView, Icon } from 'components/common'
import FiltersModal from 'containers/field-data/FiltersModal'
import useFieldDataFilters from 'hooks/useFieldDataFilters'
import FieldDataTable from 'containers/field-data/FieldDataTable'
import FilterDisplay from 'containers/field-data/FilterDisplay'


const FieldDataPage = () => {

  const DEFAULT_URL = "field-data"
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
  const { setPageSubtitle } = useContext(AppContext)
  const { filters, getFieldData } = useContext(FieldDataContext)
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)


  const filterOptions = useFieldDataFilters()

  
  const toggleModal = () => setShowModal(currentState => !currentState)
  
  useEffect(() => {
      setPageSubtitle(t('fieldData.pageTitle'))
  }, [setPageSubtitle, t])

  useEffect(() => {
    //registryLogOld('Page In' , DEFAULT_URL)
    registryLog(DEFAULT_URL, 'navigation', 'page_in')
    setLoading(true)
    getFieldData().then(() => {

    }).catch(e => {
      console.debug(e)
    }).finally(() => setLoading(false))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onRefreshClick = () => {
    //registryLogOld('Refresh' , DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'refresh')
    setLoading(true)
    getFieldData().then(() => {

    }).catch(e => {
      console.debug(e)
    }).finally(() => setLoading(false)) 
  }

  
  return <FlexView flex="1" position="relative" alignSelf="stretch">
    <FlexView flexDirection="row" alignItems="center" justifyContent="flex-start" alignSelf="stretch" margin="16px">
      <Icon name='report' width="30px" height="36px"></Icon>
      <FlexView fontSize="big" fontWeight="bold" color="gray" margin="0px 8px 0px 8px">{t('fieldData.pageSubtitle')}</FlexView>
    </FlexView>

    <FlexView margin="10px 16px 4px" flexDirection="row" justifyContent="space-between" alignSelf="stretch">       
      <FilterDisplay options={filterOptions} onTagClick={toggleModal} />
      <FlexView flexDirection="row" alignItems="center" justifyContent="flex-end" flex="1">
        <Icon name="refresh" width="28px" height="28px" margin="0px 18px 0px 0px" tooltip={t('Refresh')} onClick={onRefreshClick} />
        <Icon name="filter" width="28px" height="28px" margin="0px 8px 0px 0px" tooltip={t('Filter')} onClick={toggleModal} color={Object.keys(filters).length === 0 ? 'gray' : 'success'} />
      </FlexView>
    </FlexView>
    <FieldDataTable />
    <FiltersModal isOpen={showModal} onOutsideClick={toggleModal} options={filterOptions} />
    <LoadingOverlay visible={loading} />
  </FlexView>
}

export default FieldDataPage
